import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async getRates(to = "USD,PEN,GBP") {
    const response = await api.get(API_URL + `public/rates?to=${encodeURIComponent(to)}`);
    return response.data;
  },
};
